"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _number = require("../../utils/number");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var headingMetaProps = {
  itemProp: 'aggregateRating',
  itemScope: true,
  itemType: 'https://schema.org/AggregateRating'
};
var HotelRatingSquare = function HotelRatingSquare(props) {
  var value = props.value,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'default' : _props$size,
    _props$showMeta = props.showMeta,
    showMeta = _props$showMeta === void 0 ? false : _props$showMeta,
    count = props.count;
  if (!value) return null;
  var ratingMetaProps = showMeta ? headingMetaProps : {};
  var aggregatedRatingAttributes = function aggregatedRatingAttributes(countParams) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "worstRating",
      content: "1"
    }), /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "bestRating",
      content: "10"
    }), /*#__PURE__*/_react["default"].createElement("meta", {
      itemProp: "ratingCount",
      content: countParams
    }));
  };
  var formattedRating = (0, _number.toDecimalString)(value, 1);
  if (formattedRating === '10.0') formattedRating = formattedRating.slice(0, -2);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: className
  }, ratingMetaProps), showMeta && count ? aggregatedRatingAttributes(count) : null, /*#__PURE__*/_react["default"].createElement(StyledRating, {
    $value: value,
    $size: size
  }, formattedRating));
};
var StyledRating = _styledComponents["default"].div.withConfig({
  displayName: "HotelRatingSquare__StyledRating",
  componentId: "sc-16u8alm-0"
})(["display:flex;justify-content:center;align-items:center;padding:3px 8px;color:var(--primary-color);font-style:normal;font-weight:500;border-radius:var(--border-radius);background-color:var(--background);", " ", ""], function (_ref) {
  var $value = _ref.$value;
  return $value >= 8.0 && (0, _styledComponents.css)(["background-color:var(--primary);"]);
}, function (_ref2) {
  var $size = _ref2.$size;
  switch ($size) {
    case 'small':
      return (0, _styledComponents.css)(["padding:none;width:30px;height:20px;font-size:14px;line-height:18px;"]);
    case 'default':
    default:
      return (0, _styledComponents.css)(["font-size:22px;line-height:26px;"]);
  }
});
var _default = exports["default"] = HotelRatingSquare;